import { ADDRESS_MODEL_CLASS_NAME } from 'models/daos/address/constants'
import { COMMENT_MODEL_CLASS_NAME } from 'models/daos/comment/constants'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { PRODUCT_MODEL_CLASS_NAME } from 'models/daos/product/constants'
import { PROMO_CODE_MODEL_CLASS_NAME } from 'models/daos/promo-code/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'
import { CREDENTIAL_CLASS_NAME } from 'models/daos/credential/constants'
import { getValidatorUtil } from 'modules/redux/validators/legacy'
import { getValidatorAddressUtil } from 'modules/address/utils'
import { getValidatorCategoryUtil } from 'models/daos/category/utils'
import { getValidatorCommentUtil } from 'models/daos/comment/utils'
import { getValidatorPromoCodeUtil } from 'models/daos/promo-code/utils'
import { getValidatorProductUtil } from 'models/daos/product/utils'
import { getValidatorUserUtil } from 'models/daos/user/utils'
import { getValidatorCredentialUtil } from 'modules/credential/utils'
import { formatInstanceBeforeValidate } from 'models/formatters/before-validate'
import { MODEL_KEY } from 'modules/redux/constants/model-key'
import {
  isPlainObjectUtil,
  omitObjectUtil
} from 'packages/src'

/**
 * A mapping of className to validator.
 * @type {Object}
 */
const VALIDATOR = {
  [ADDRESS_MODEL_CLASS_NAME]: getValidatorAddressUtil,
  [CATEGORY_MODEL_CLASS_NAME]: getValidatorCategoryUtil,
  [COMMENT_MODEL_CLASS_NAME]: getValidatorCommentUtil,
  [CREDENTIAL_CLASS_NAME]: getValidatorCredentialUtil,
  [PRODUCT_MODEL_CLASS_NAME]: getValidatorProductUtil,
  [PROMO_CODE_MODEL_CLASS_NAME]: getValidatorPromoCodeUtil,
  [USER_MODEL_CLASS_NAME]: getValidatorUserUtil
}

/**
 * Validates every property of the given `data`.
 * @param  {Object} dataToValidate
 * @param  {string} className
 * @param  {Object} data
 * @returns {Object}
 */
function validateModelUtil (dataToValidate, className, data) {
  let validateValue
  let validateKey
  dataToValidate = omitObjectUtil(dataToValidate, Object.keys(MODEL_KEY))
  const keys = Object.keys(dataToValidate)
  // If there is no data to validate,
  // noop
  if (!keys.length) {
    return true
  }
  // Validate every attribute
  keys.every(key => {
    const value = dataToValidate[key]
    // Format the value before validation
    const formattedData = formatInstanceBeforeValidate({
      data: { [key]: value },
      className
    })
    let validatorFn = VALIDATOR[className] && VALIDATOR[className](key)
    if (!validatorFn) {
      validatorFn = getValidatorUtil(key)
    }
    if (!validatorFn) {
      validateValue = true
      return true
    }
    validateValue = validatorFn(formattedData[key], className, data)
    validateKey = key
    return validateValue === true
  })
  if (validateValue === true) {
    return true
  } else if (isPlainObjectUtil(validateValue)) {
    return validateValue
  }
  return {
    key: validateKey,
    value: validateValue
  }
}

export {
  validateModelUtil
}
